import { Offer } from './FormulaNode/Contexts/FreeResiliationFormulaContext/types';

export interface BoxPrice extends Offer {
  __typename: 'BoxPrice';
}

export interface MobilePrice extends Offer {
  __typename: 'MobilePrice';
}

const PriceBoxRevolution: BoxPrice = {
  __typename: 'BoxPrice',
  firstYear: 29.99,
  id: 'revolution-light',
  name: 'Révolution Light',
  setupFees: 49.99,
};

const PriceBoxPop: BoxPrice = {
  __typename: 'BoxPrice',
  firstYear: 29.99,
  secondYear: 39.99,
  id: 'pop',
  name: 'POP',
};

const PriceBoxDeltaPop: BoxPrice = {
  __typename: 'BoxPrice',
  firstYear: 39.99,
  secondYear: 49.99,
  name: 'Delta POP',
  id: 'delta-pop',
};

const PriceBoxCrystal: BoxPrice = {
  __typename: 'BoxPrice',
  firstYear: 35.98,
  name: 'Crystal',
  id: 'crystal',
};

const PriceBoxUltraEssentielle: BoxPrice = {
  __typename: 'BoxPrice',
  firstYear: 39.99,
  secondYear: 49.99,
  name: 'Ultra Essentielle',
  id: 'ultra-essentielle',
};

const PriceBoxUltra: BoxPrice = {
  __typename: 'BoxPrice',
  firstYear: 49.99,
  secondYear: 59.99,
  name: 'Ultra',
  id: 'ultra',
};

const PriceMobile5G: MobilePrice = {
  __typename: 'MobilePrice',
  firstYear: 19.99,
  name: 'Free 5G',
  id: 'free-5g',
};

const PriceMobile5GWithUltra: MobilePrice = {
  __typename: 'MobilePrice',
  firstYear: 9.99,
  secondYear: 15.99,
  name: 'Free 5G avec avantage Freebox Ultra',
  id: 'free-5g-ultra',
};

const PriceMobile5GWithAdvantage: MobilePrice = {
  __typename: 'MobilePrice',
  firstYear: 15.99,
  name: 'Free 5G avec avantage Freebox',
  id: 'free-5g-avantage-box',
};

const PriceMobile5GWithPopAdvantage: MobilePrice = {
  __typename: 'MobilePrice',
  firstYear: 9.99,
  name: 'Free 5G avec avantage Freebox POP',
  id: 'free-5g-avantage-pop',
};

export const PriceSerieFreeBoxVariable: Omit<MobilePrice, 'firstYear'> = {
  __typename: 'MobilePrice',
  name: 'Série Free avec avantage Box',
  id: 'serie-free-box',
  secondYear: 15.99,
};

export const PriceSerieFreeVariable: Omit<MobilePrice, 'firstYear'> = {
  __typename: 'MobilePrice',
  name: 'Série Free',
  id: 'serie-free',
  secondYear: 19.99,
};

export const freeOffers = [
  PriceBoxRevolution,
  PriceBoxPop,
  PriceBoxDeltaPop,
  PriceBoxCrystal,
  PriceBoxUltraEssentielle,
  PriceBoxUltra,
  PriceMobile5G,
  PriceMobile5GWithUltra,
  PriceMobile5GWithAdvantage,
  PriceMobile5GWithPopAdvantage,
];

export const Operators = [
  {
    name: 'Orange',
    closingFee: 50,
  },
  {
    name: 'SFR',
    closingFee: 49,
  },
  {
    name: 'Bouygues Telecom',
    closingFee: 59,
  },
  {
    name: 'Sosh',
    closingFee: 50,
  },
  {
    name: 'RED by SFR',
    closingFee: 49,
  },
];
